// extracted by mini-css-extract-plugin
export default {"root":"CompareModeView_root__XdElO","container":"CompareModeView_container__Ee7Fy","reducedHeight":"CompareModeView_reducedHeight__ETdB4"};